module.exports = __webpack_public_path__ + "img/union.1ce9f91.png";